<template>
	<div class="container g-0">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" >
.container {
  max-width: initial;
}
</style>